module.exports = __webpack_public_path__ + "img/ep7-10.33bf2ec3.png";